import { z } from "zod";

export const registerSchema = z.object({
  phone: z.string().min(7, "Enter a valid phone number"),
  password: z.string().min(8, "Password must be at least 8 characters"),
  fullName: z.string().min(2),
  email: z.string().email().optional().or(z.literal(""))
});
export type RegisterInput = z.infer<typeof registerSchema>;

export const loginSchema = z.object({
  identifier: z.string().min(1, "Enter your email or phone number"),
  password: z.string().min(1)
});
export type LoginInput = z.infer<typeof loginSchema>;

export const googleAuthSchema = z.object({
  idToken: z.string().min(10)
});
export type GoogleAuthInput = z.infer<typeof googleAuthSchema>;

const pinSchema = z.string().regex(/^\d{6}$/, "PIN must be exactly 6 digits");

export const verifyPinSchema = z.object({
  challengeToken: z.string().min(1),
  pin: pinSchema
});
export type VerifyPinInput = z.infer<typeof verifyPinSchema>;

export const setupPinSchema = z.object({
  challengeToken: z.string().min(1),
  pin: pinSchema
});
export type SetupPinInput = z.infer<typeof setupPinSchema>;

export const changePasswordSchema = z
  .object({
    currentPassword: z.string().min(1),
    newPassword: z.string().min(8, "Password must be at least 8 characters")
  })
  .refine((v) => v.currentPassword !== v.newPassword, {
    message: "New password must be different from the current password",
    path: ["newPassword"]
  });
export type ChangePasswordInput = z.infer<typeof changePasswordSchema>;

export const changePinSchema = z.object({
  currentPassword: z.string().min(1),
  newPin: pinSchema
});
export type ChangePinInput = z.infer<typeof changePinSchema>;

export const changeEmailSchema = z.object({
  currentPassword: z.string().min(1),
  newEmail: z.string().trim().email("Enter a valid email")
});
export type ChangeEmailInput = z.infer<typeof changeEmailSchema>;

export const adminResetPasswordSchema = z.object({
  newPassword: z.string().min(8, "Password must be at least 8 characters")
});
export type AdminResetPasswordInput = z.infer<typeof adminResetPasswordSchema>;
